module.exports = __webpack_public_path__ + "img/sp_foot_ico05.a6b3ece7.svg";